import React from "react"
import PropTypes from "prop-types"
import TextFieldNumber from "common/TextFieldNumber"

const FooterTextField = ({
  label,
  value,
  suffix,
  disabled,
  readOnly,
  onChange,
  onBlur,
  isPercentage,
  decimalScale = 2,
  sx = {},
}) => {
  const handleBlur = val => {
    if (val === "" || val === undefined) {
      onChange(0)
    }
    if (typeof onBlur === "function") {
      onBlur(val)
    }
  }
  return (
    <TextFieldNumber
      label={label}
      variant="filled"
      size="small"
      value={value}
      suffix={suffix}
      disabled={disabled}
      readOnly={readOnly}
      isPercentage={isPercentage}
      decimalScale={decimalScale}
      InputProps={{ disableUnderline: true }}
      onChange={onChange}
      onBlur={handleBlur}
      sx={{
        backgroundColor: "white",
        "& .MuiFilledInput-root": {
          border: "none",
          backgroundColor: "transparent",
          boxShadow: "none",
        },
        "& .MuiFilledInput-root:before": { border: "none" },
        "& .MuiFilledInput-root:after": { border: "none" },
        "& .MuiFilledInput-root.Mui-disabled": {
          backgroundColor: "#F6F7FB",
          color: "rgba(0, 0, 0, 1) !important",
        },
        "& .MuiFilledInput-root.Mui-disabled input": {
          WebkitTextFillColor: "revert",
        },
        ...sx,
      }}
    />
  )
}
FooterTextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  suffix: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  isPercentage: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  decimalScale: PropTypes.number,
  sx: PropTypes.object,
}
FooterTextField.defaultProps = {
  value: "0",
  disabled: false,
  isPercentage: false,
  suffix: "€",
  onBlur: () => {},
  onChange: () => {},
  decimalScale: 2,
}

export default FooterTextField
